import React, { useState } from "react";
import { Paper, TextField, Button, Typography, Alert } from "@mui/material";
import { styles } from "./AuthPage.styles";

const ForgotPassword = ({
  onBackToSignIn,
  handleForgotPassword,
  loading,
  error,
}) => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await handleForgotPassword(email);
    if (result) {
      setSuccess(true);
    }
  };

  return (
    <Paper elevation={3} sx={styles.paper}>
      <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
        Reset Password
      </Typography>

      {error && (
        <Alert severity="error" sx={styles.errorAlert}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Password reset email sent! Please check your inbox.
        </Alert>
      )}

      <form onSubmit={handleSubmit} style={styles.form}>
        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
          required
          sx={styles.textField}
          variant="standard"
          InputLabelProps={{
            shrink: true,
          }}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          sx={styles.submitButton}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </Button>

        <Button
          fullWidth
          variant="text"
          onClick={onBackToSignIn}
          sx={{ mb: 2 }}
        >
          Back to Sign In
        </Button>
      </form>
    </Paper>
  );
};

export default ForgotPassword;
